module.exports = __webpack_public_path__ + "media/images/lb/028-8c5d21cc648ecd5a529f6df90a957f70.svg";